import type { ListConstellationSessionsParams, SessionType } from "../domain/types";
import { ConstellationAPI } from "../infrastructure/api/Constellation.api";

export async function launchConstellation(
    sessionType: SessionType,
    patientId: string | null,
    couplePatientId?: string,
    title?: string,
    sceneId?: string,
    groupPatientId?: string,
) {
    const { data } = await ConstellationAPI.launch(
        sessionType,
        patientId,
        couplePatientId,
        title,
        sceneId,
        groupPatientId,
    );
    return data;
}

export async function listConstellationSessions(params?: ListConstellationSessionsParams) {
    const { data } = await ConstellationAPI.listSessions(params);
    return data;
}

export async function deleteConstellationSession(sessionId: string): Promise<void> {
    await ConstellationAPI.deleteSession(sessionId);
}

export async function getSessionBoardSummary(sessionId: string) {
    const { data } = await ConstellationAPI.getSessionBoardSummary(sessionId);
    return data;
}

export async function newSessionFromSession(sessionId: string) {
    const { data } = await ConstellationAPI.newSessionFromSession(sessionId);
    return data;
}

export async function joinConstellationBoard(token: string, displayName: string) {
    const { data } = await ConstellationAPI.joinBoard(token, displayName);
    return data;
}

export async function createConstellationScene(
    payload: Parameters<typeof ConstellationAPI.createScene>[0],
) {
    const { data } = await ConstellationAPI.createScene(payload);
    return data;
}
